// Registers every Monaco language and feature (react-monaco-editor only imports editor.api),
// as monaco-editor-webpack-plugin did.
import "monaco-editor/esm/vs/editor/editor.main";
import editorWorkerUrl from "monaco-editor/esm/vs/editor/editor.worker?worker&url";
import jsonWorkerUrl from "monaco-editor/esm/vs/language/json/json.worker?worker&url";
import cssWorkerUrl from "monaco-editor/esm/vs/language/css/css.worker?worker&url";
import htmlWorkerUrl from "monaco-editor/esm/vs/language/html/html.worker?worker&url";
import tsWorkerUrl from "monaco-editor/esm/vs/language/typescript/ts.worker?worker&url";

const workerUrls: { [label: string]: string } = {
  json: jsonWorkerUrl,
  css: cssWorkerUrl,
  scss: cssWorkerUrl,
  less: cssWorkerUrl,
  html: htmlWorkerUrl,
  handlebars: htmlWorkerUrl,
  razor: htmlWorkerUrl,
  typescript: tsWorkerUrl,
  javascript: tsWorkerUrl,
};

// Assets can live on another origin (CDN), and a Worker must be same-origin,
// so the real script is loaded through a same-origin blob.
function createWorker(url: string) {
  const absUrl = new URL(url, location.href).href;
  const blob = new Blob([`importScripts(${JSON.stringify(absUrl)});`], { type: "text/javascript" });
  return new Worker(URL.createObjectURL(blob));
}

(self as any).MonacoEnvironment = {
  getWorker(_: string, label: string) {
    return createWorker(workerUrls[label] || editorWorkerUrl);
  },
};
